/**
 * Labstep
 *
 * @module components/FilterPost/Report/Text
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportOptionsForm } from 'labstep-web/components/FilterPost/Report/Options/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostReportOptionsProps } from './types';

export const FilterPostReportOptions: React.FC<
  FilterPostReportOptionsProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  entityName,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportOptionsForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        entityName={entityName}
      />
    )}
    {...rest}
  />
);
